import { CandidateLastAccessRange } from "@/pb/scout/candidate/v1/candidate_pb";

export interface SearchOptionParam {
  keyword: string;
  graduateYears: string[];
  aspiringBusinessCategoryIds: number[];
  preferredJobTypeIds: number[];
  universityAreaIds: number[];
  universityNames: string[];
  grades: string[];
  isUsingInformationForWomen: boolean | undefined;
  courses: string[];
  departmentNames: string[];
  concentrationNames: string[];
  highSchoolName: string;
  internshipResultCompanyNames: string[];
  programmingSkillNames: string[];
  programmingSkillYearOfUses: string[];
  lastAccessRangeKey: CandidateLastAccessRange;
  votedUserOnly: boolean;
  voterUserOnly: boolean;
  activityCategories: ActivityCategory[];
  uniqueId: string;
  selfPromotionExists: boolean;
  studentEndeavorExists: boolean;
  lineIdExists: boolean;
  preferredWorkPrefectureIds: number[];
  companyChoiceFactorTypeIds: number[];
  internshipResultExists: boolean;
}

export type ActivityCategory = {
  largeCategoryName: string;
  mediumCategoryNames: string[];
};

export const defaultSearchOptionParam: SearchOptionParam = {
  keyword: "",
  graduateYears: [],
  aspiringBusinessCategoryIds: [],
  preferredJobTypeIds: [],
  universityAreaIds: [],
  universityNames: [],
  grades: [],
  isUsingInformationForWomen: undefined,
  courses: [],
  departmentNames: [],
  concentrationNames: [],
  highSchoolName: "",
  internshipResultCompanyNames: [],
  programmingSkillNames: [],
  programmingSkillYearOfUses: [],
  lastAccessRangeKey:
    CandidateLastAccessRange.CANDIDATE_LAST_ACCESS_RANGE_UNSPECIFIED,
  votedUserOnly: false,
  voterUserOnly: false,
  activityCategories: [],
  uniqueId: "",
  selfPromotionExists: false,
  studentEndeavorExists: false,
  lineIdExists: false,
  preferredWorkPrefectureIds: [],
  companyChoiceFactorTypeIds: [],
  internshipResultExists: false
};
